export default {
  path: '/terms',
  name: 'terms',
  component: () => import(/* webpackChunkName: "auth" */ '@/views/Terms/index'),
}
